import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { ReceiveFlow } from './receive-flow';

export interface ReceiveModalProps {
  open: boolean;
  onClose: () => void;
  coin?: CryptoAsset;
  suiAddress: string | undefined;
}

export const ReceiveModal = ({ open, onClose, coin, suiAddress }: ReceiveModalProps) => (
  <ReceiveFlow
    presentation="modal"
    open={open}
    onClose={onClose}
    coin={coin}
    suiAddress={suiAddress}
  />
);
